import React from "react";
import { H1, H3, Cluster, Stack } from "@wigxel/react-components";

const Intro = React.forwardRef((props, ref) => {
  return (
    <section className="intro" ref={ref}>
      <div className="container px-5">
        <Stack large>
          <hgroup>
            <H3 className="font-sans" style={{ fontWeight: 100 }}>Welcome To</H3>
            <H1>THE MEDIA AWARDS</H1>
            <H3 className="font-sans" style={{ fontWeight: 100 }}>VOTING PORTAL</H3>
          </hgroup>
          <Cluster.Small vertical>{props.children}</Cluster.Small>
        </Stack>
      </div>
    </section>
  );
});

export default Intro;
